// import uuidParse from 'uuid-parse';
// import { enc } from 'crypto-js';

export const createRandomString = function (length = 10): string {
  let result = '';
  while (result.length < length) {
    result += Math.random().toString(36).substring(2);
  }
  return result.substring(0, length);
};

/**
 * Compare strings, use lowercase transformation
 */
export const equalsIgnoreCase = function (
  text1?: string,
  text2?: string
): boolean {
  if (!text1 && !text2) {
    return true;
  }
  if (!text1 || !text2) {
    return false;
  }
  return text1.toLowerCase() === text2.toLowerCase();
};

/**
 * Typesafe toLowerCase which works with strings that are defined `as const`
 */
// export function toLowerCase<T extends string>(str: T): `${Lowercase<T>}` {
//   return str.toLowerCase() as `${Lowercase<T>}`;
// }

/**
 * Convert UUID to hex representation
 *  (Remove dashes, and transform to 0x form)
 * @param uuid 797ff043-11eb-11e1-80d6-510998755d10
 */
// export const convertUuidToHex = (uuid: string): string => {
//   const buffer = uuidParse.parse(uuid);
//   return '0x' + Buffer.from(buffer).toString('hex');
// };

export const uuidToHexString = (uuid: string): string =>
  `0x${uuid.replace(/-/g, '')}`;

// https://github.com/joaquimserafim/base64-url/blob/master/index.js
// export function escapeBase64(str: string): string {
//   return str
//     .replace(/\+/g, '-')
//     .replace(/\//g, '_')
//     .replace(/=/g, '');
// }

// export function unescapeBase64(str: string): string {
//   return (str + '==='.slice((str.length + 3) % 4))
//     .replace(/-/g, '+')
//     .replace(/_/g, '/');
// }

// export function encodeStringToBase64ForUrl(str: string) {
//   return escapeBase64(btoa(str));
// }

// export function decodeBase64Url(str: string) {
//   return atob(unescapeBase64(str));
// }

/**
 * Create cammelcase string
 */
// export function camelize(str: string): string {
//   return str
//     .replace(/-/g, ' ')
//     .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
//       return index === 0 ? word.toLowerCase() : word.toUpperCase();
//     })
//     .replace(/\s+/g, '');
// }

export const copyTextToClipboard = (text: string): void => {
  if (!navigator?.clipboard?.writeText) {
    alert('Copy is not supported in your web browser');
  }
  navigator.clipboard.writeText(text);
};

export function textTrimWith3DotsInMiddle(
  string: string,
  maxLength: number
): string {
  if (!string) {
    return string;
  }
  if (maxLength < 1) {
    return string;
  }
  if (string.length <= maxLength) {
    return string;
  }
  if (maxLength === 1) {
    return string.substring(0, 1) + '...';
  }

  const midpoint = Math.ceil(string.length / 2);
  const toremove = string.length - maxLength;
  const lstrip = Math.ceil(toremove / 2);
  const rstrip = toremove - lstrip;
  return (
    string.substring(0, midpoint - lstrip) +
    '...' +
    string.substring(midpoint + rstrip)
  );
}

export function capitalizeFirstLetter(text?: string): string {
  if (!text || text.length === 0) {
    return '';
  }
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function selectContents(el: any) {
  const range = document.createRange();
  range.selectNodeContents(el);
  const sel = window.getSelection();
  sel?.removeAllRanges();
  sel?.addRange(range);
}

/**
 * Join text like
 *  ['one', 'two', 'three'] ==> 'one, two and three'
 */
export function joinWordsWithAndAtTheEnd(words: string[]) {
  return [words.slice(0, -1).join(', '), words.slice(-1)[0]].join(
    words.length < 2 ? '' : ' and '
  );
}

export function truncateText(text: string, maxLength: number): string {
  if (!text) {
    return '';
  }
  if (text.length <= maxLength) {
    return text;
  }
  if (maxLength <= 3) {
    return text.substring(0, maxLength);
  }
  return text.substring(0, maxLength - 3) + '...';
}

export function truncateAddressInTheMiddle(text?: string): string {
  if (!text) {
    return '';
  }
  const frontChars = 6;
  const backChars = 4;
  if (text.length < 10) {
    return text; // not address
  }
  return (
    text.substring(0, frontChars) +
    '...' +
    text.substring(text.length - backChars)
  );
}

/**
 * Directly derive v1 timestamp fields from the raw bigint without formatting
 * to UUID string and reparsing. Using big-endian reads on the canonical hex groups.
 * Layout (RFC 4122): time_low (8 hex) | time_mid (4 hex) | time_hi_and_version (4 hex)
 * @returns unix ms timestamp
 */
export function getUUIDv1Timestamp(rawUUID: bigint) {
  const hex = rawUUID.toString(16).padStart(32, '0');
  const timeLow = parseInt(hex.slice(0, 8), 16); // 32 bits
  const timeMid = parseInt(hex.slice(8, 12), 16); // 16 bits
  const timeHiAndVersion = parseInt(hex.slice(12, 16), 16); // 16 bits (version in high 4)
  const timeHi = timeHiAndVersion & 0x0fff; // keep lower 12 bits
  const timestamp =
    (BigInt(timeHi) << 48n) | (BigInt(timeMid) << 32n) | BigInt(timeLow);
  const UUID_EPOCH = 0x01b21dd213814000n; // 1582-10-15
  // UUID v1 timestamp is in 100ns intervals. Convert to Unix ms
  return Number((timestamp - UUID_EPOCH) / 10000n);
}

// function formatUUID(uuidBigInt: bigint): string {
//   // Convert bigint to hex string (32 characters, padded with zeros)
//   const hexString = uuidBigInt.toString(16).padStart(32, '0');
//   // Insert dashes at appropriate positions for UUID format
//   return hexString.replace(
//     /^(.{8})(.{4})(.{4})(.{4})(.{12})$/,
//     '$1-$2-$3-$4-$5'
//   );
// }
// import { parse } from 'uuid';
// export function getUUIDv1Timestamp(rawUUID: bigint) {
//   const uuid = formatUUID(rawUUID);
//   const uuidBytes = Buffer.from(parse(uuid));
//
//   const timeLow = uuidBytes.readUInt32BE(0);
//   const timeMid = uuidBytes.readUInt16BE(4);
//   const timeHi = uuidBytes.readUInt16BE(6) & 0x0fff;
//   const timestamp =
//     (BigInt(timeHi) << 48n) | (BigInt(timeMid) << 32n) | BigInt(timeLow);
//
//   const UUID_EPOCH = 0x01b21dd213814000n;
//   const unixTs = (timestamp - UUID_EPOCH) / 10000n;
//
//   return Number(unixTs);
// export async function sha256Hex(text: string) {
//   const utf8 = new TextEncoder().encode(text);
//   const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
//   const hashArray = Array.from(new Uint8Array(hashBuffer));
//   return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
// }

// /** Generate simple hash from text with unlimited lenght */
// export function simpleHash(text: string): number {
//   console.log({ text });
//   if (!text) {
//     return 0;
//   }
//   let hash = 0;
//   for (let i = 0; i < text.length; i++) {
//     hash = (hash << 5) - hash + text.charCodeAt(i);
//     hash |= 0; // Convert to 32bit integer
//   }
//   return hash >>> 0;
// }
